import type { CheckStatus } from '@fkwd-qc/shared';
import { statusTone } from '@/lib/status';

/**
 * Props for a status square.
 *
 * @since 1.0.0
 */
export interface StatusDotProps {
    status: CheckStatus;
    label?: string;
    isSmall?: boolean;
}

/**
 * The square that reports one check outcome, with a glyph per tone so colour is never the
 * only signal. It announces itself when given a label and hides when the control around it
 * already does.
 *
 * @since 1.0.0
 * @param props - status, optional accessible label and size
 * @returns the status square element
 */
export function StatusDot({ status, label, isSmall = false }: StatusDotProps) {
    const classNames = ['fkwd-dot', `fkwd-dot--${statusTone(status)}`];

    if (isSmall) {
        classNames.push('fkwd-dot--small');
    }

    if (label === undefined) {
        return <span aria-hidden="true" className={classNames.join(' ')} />;
    }

    return <span aria-label={label} className={classNames.join(' ')} role="img" title={label} />;
}
